import { Component, OnInit, HostListener, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatSort, SortDirection } from "@angular/material";
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../store/reducers';
import * as extractsActions from '../store/actions';
import * as dashboardActions from '../../pillar/dashboard/store/actions';
import { ModuleConfiguration } from '../extracts.module.config';
import { Actions } from '@ngrx/effects';
import { StoreDataSource } from '../../core/services/StoreDataSource';
import { ExtractModel } from "../models/ExtractModel";
import { ExtractListModel } from "../models/ExtractListModel";
import { SearchComponent } from '../../pillar/search/components/search.component';

@Component({
  selector: 'brd-extracts-dashboard',
  templateUrl: './extracts-dashboard.component.html',
  styleUrls: ['./extracts-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExtractsDashboardComponent implements OnInit {
  displayedCategoryColumns = ['name'];
  static dashboardName = 'extracts';
  extractListLoading$: Observable<boolean>;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  extractCategories$: Observable<ExtractModel[]>;
  loading = true;
  categoryLoading = true;
  selectedExtract: ExtractModel;
  dataSource: StoreDataSource<ExtractListModel>;
  extractList$: Observable<ExtractListModel[]>;
  extractCategorySelected$: Observable<ExtractModel>;
  extractCategorySelected = false;
  currentPage$: Observable<number>;
  searchInput = 'ExtractsModule_SearchInput';
  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort;
  @ViewChild(SearchComponent)
  search: SearchComponent;

  constructor(private store: Store<any>,
    private changeDetectorRef: ChangeDetectorRef,
    private actions$: Actions) {
    this.currentPage$ = this.store.select(fromStore.getExtractListCurrentPage);
  }

  ngOnInit() {
    this.store.dispatch(new extractsActions.GetExtractCategoryQueryAction({ page: 0, pageSize: 200 }))    ;
    this.extractCategories$ = this.store.select(fromStore.getExtractCategoryList);
    this.extractCategorySelected$ = this.store.select(fromStore.getExtractCategorySelected);

    this.actions$.ofType(extractsActions.GET_EXTRACT_CATEGORY_QUERY_SUCCESS)
      .takeUntil(this.destroyed$)
      .subscribe(() => {
        this.categoryLoading = false;
      });
  }

  selectExtract(extract: ExtractModel) {
    this.loading = true;
    this.selectedExtract = extract;
    this.store.dispatch ( new extractsActions.SetSelectedExtractModelAction ( { model: this.selectedExtract }));
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    //Keep this method here as it causes an angular digest which keeps the sidnav width correctly updated
  }
}



// WEBPACK FOOTER //
// ./src/app/extracts/components/extracts-dashboard.component.ts